export const replacePlaceholders = (str: string, placeholders: any) => {
  return str.replace(/{{(.*?)}}/g, (match, p1) => {
    return placeholders[p1] || match;
  });
};